import React from 'react'
import moment from 'moment'

const AnnountmentHeader = ({ isOverride }) => {
  const dateNow = Date.now()
  const [startTime, endTime] = [1645754400000, 1646614800000]
  if (isOverride || (dateNow >= startTime && dateNow <= endTime)) {
    return (
      <div className="announcementHeader__container" role="alert" aria-live="assertive">
        <h5>
          The maintenance of this website is scheduled for March 7, 2022 from 9pm to 11pm. During
          this time the website will be unavailable.
        </h5>
      </div>
    )
  }
  return null
}

export default AnnountmentHeader
